/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    noDataPlaceholder: "No data",
    noSelectedValuePlaceholder: {
        default: "Select a value",
        plural: "Select value(s)"
    }
};